// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const ArticleProfileModalRecord = require('client-v2/common/containers/article-profile/state/modal-record')
const AuthModalRecord = require('client-v2/common/containers/auth-modal/record')
const CollectionSelectModalRecord = require('client-v2/common/containers/collection-select-modal/record')
const ConfirmModalRecord = require('client-v2/common/containers/confirm-modal/record')
const ContentAddModalRecord = require('client-v2/common/containers/content-add-modal/record')
const LightweightEngagementTutorialRecord = require('client-v2/common/containers/lightweight-engagement/containers/tutorial/record')
const SearchFormRecord = require('client-v2/common/containers/search-form/record')
const ShareModalRecord = require('client-v2/common/containers/share-modal/record')
const ToastsRecord = require('client-v2/common/containers/toasts/record')
const TooltipsRecord = require('client-v2/common/containers/tooltips/record')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const GlobalUserRecord = require('client-v2/common/state/user/record')
const { keyedReviver } = require('client-v2/common/state/revivers')
// Entry imports
const FeedRecord = require('client-v2/user-profile/containers/feed/record')
const ProfileUserRecord = require('client-v2/user-profile/containers/profile-user/record')
const ProfileUserStatsRecord = require('client-v2/user-profile/containers/profile-user-stats/record')

class UserProfileRootRecord extends Immutable.Record({
  // Common state
  env: null,
  router: null,
  user: null,
  // Common containers
  articleProfileModal: null,
  authModal: null,
  collectionSelectModal: null,
  confirmModal: null,
  contentAddModal: null,
  lightweightEngagementTutorial: null,
  searchForm: null,
  shareModal: null,
  toasts: null,
  tooltips: null,
  // Entry containers
  feed: null,
  profileUser: null,
  profileUserStats: null
}) {
  // No methods
}

UserProfileRootRecord.reviver = keyedReviver(UserProfileRootRecord, {
  // Common state
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: GlobalUserRecord.reviver,
  // Common containers
  articleProfileModal: ArticleProfileModalRecord.reviver,
  authModal: AuthModalRecord.reviver,
  collectionSelectModal: CollectionSelectModalRecord.reviver,
  confirmModal: ConfirmModalRecord.reviver,
  contentAddModal: ContentAddModalRecord.reviver,
  lightweightEngagementTutorial: LightweightEngagementTutorialRecord.reviver,
  searchForm: SearchFormRecord.reviver,
  shareModal: ShareModalRecord.reviver,
  toasts: ToastsRecord.reviver,
  tooltips: TooltipsRecord.reviver,
  // Entry containers
  feed: FeedRecord.reviver,
  profileUser: ProfileUserRecord.reviver,
  profileUserStats: ProfileUserStatsRecord.reviver
})

module.exports = UserProfileRootRecord
